import { CARD_TYPE_MAP } from '../cardTypes';

const CARD_TYPES_WITH_SAMPLES = [CARD_TYPE_MAP.std, CARD_TYPE_MAP.invitation] as const;

export type CardTypeWithSamples = (typeof CARD_TYPES_WITH_SAMPLES)[number];

export const isCardTypeWithSamples = (type?: string): type is CardTypeWithSamples => {
  if (!type) return false;
  return (CARD_TYPES_WITH_SAMPLES as Readonly<string[]>).includes(type);
};
